import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { resetQueries } from '@/utils'
import { getApiErrorMessage } from '@/utils/error'

import { GET_CHECKLISTS_BASE_QUERY_KEY } from './get-checklists'

interface BulkSendReminderChecklistsRequest {
  checklistIds: number[]
  buildingId: number
}

interface BulkSendReminderChecklistsResponse {
  completed: number[]
  failed: {
    id: number
    status: number
    message: string
  }[]
}

export const bulkSendReminderChecklists = async (data: BulkSendReminderChecklistsRequest) => {
  const response = await authAPI.post<BulkSendReminderChecklistsResponse>(
    `/checklist-unified/${data.buildingId}/bulk-remind`,
    {
      ids: data.checklistIds,
    },
  )
  return response.data
}

export const useBulkSendReminderChecklists = () => {
  return useMutation({
    mutationFn: bulkSendReminderChecklists,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async (response) => {
      await resetQueries([GET_CHECKLISTS_BASE_QUERY_KEY])

      if (response.failed.length > 0) {
        toastFactory.error(
          `${response.completed.length} checklists reminder sent successfully, ${response.failed.length} checklists failed to send reminder`,
        )
        return
      }

      toastFactory.success('Selected checklists reminder sent successfully')
    },
  })
}
